__webpack_require__.p = "/phantombrave-the-lost-hero-fr/";